import * as React from "react";
import JobSummaryPage from "../../pages/jobs/[id]";
import { JobVehicleHistoryTabs } from "../VehicleHistory/JobVehicleHistoryTabs";
import { useHasVehicleHistory } from "../../hooks/useUiv";
import { VEHICLE_HISTORY_MOUNT, VehicleHistoryMount } from "../../lib/vehicleHistory.utils";

// VEHICLE-HISTORY (NUB-358): `tab` mode puts a switcher under the job header; `page` mode leaves the job page as before.
export const JobRoute: React.FC<{}> = () => {
  const hasVehicleHistory = useHasVehicleHistory();
  if (VEHICLE_HISTORY_MOUNT !== VehicleHistoryMount.TAB || !hasVehicleHistory) return <JobSummaryPage />;
  return <JobVehicleHistoryTabs renderJobPage={(slots) => <JobSummaryPage {...slots} />} />;
};
